import { render } from "./MrpData.vue?vue&type=template&id=2d0d41c9&scoped=true"
import script from "./MrpData.vue?vue&type=script&lang=js"
export * from "./MrpData.vue?vue&type=script&lang=js"

import "./MrpData.vue?vue&type=style&index=0&id=2d0d41c9&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d0d41c9"]])

export default __exports__